import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerFavoriteItemDTO } from '../models/customer.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private apiUrl = `${environment.apiUrl}customers`;

  constructor(private http: HttpClient) {}

  saveCustomerFavoriteItem(customerId: string, favoriteItem: CustomerFavoriteItemDTO): Observable<void> {
    const url = `${this.apiUrl}/${customerId}/favorite-item`;
    return this.http.post<void>(url, favoriteItem);
  }

  deleteCustomerFavoriteItem(customerId: string, itemId: string): Observable<void> {
    const url = `${this.apiUrl}/${customerId}/favorite-item/${itemId}`;
    return this.http.delete<void>(url);
  }

  getCustomerFavoriteItems(customerId: string): Observable<string[]> {
    const url = `${this.apiUrl}/${customerId}/favorite-items`;
    return this.http.get<string[]>(url);
  }
}